import React from 'react';
import classNames from 'classnames';
import { withTranslation } from 'next-i18next';
import { Button, ButtonsContainer, nanoid } from '@forma/forma-ui-kit';
import CopyInput from '@/components/CopyInput';
import store from '@/store';
import { userAtom } from '@/store/user';

import commonApi from '@/api/commonApi';

import styles from './error-boundary.module.css';

const tgUrl = process.env.TG_URL;
// const waUrl = process.env.WA_URL;
const email = process.env.CONTACT_EMAIL;

class ErrorBoundary extends React.Component {
  state = { id: '', hasError: false, error: null, type: null };

  showError(event) {
    const id = nanoid(7);

    this.setState({
      id,
      hasError: true,
      error: event.error.message,
      type: event.error.message.startsWith('Loading chunk') ? 'loading' : 'default'
    });

    const user = store.get(userAtom);

    commonApi.sendErrorReport({
      errorId: id,
      url: window.location.href,
      message: event.error.message,
      // attachment?: string,
      wid: user?.workspace.id,
      uid: user?.id,
    });
  };

  static getDerivedStateFromError(error) {
    const id = nanoid(7);

    const user = store.get(userAtom);

    commonApi.sendErrorReport({
      errorId: id,
      url: window.location.href,
      message: error.message,
      // attachment?: string,
      wid: user?.workspace.id,
      uid: user?.id,
    });

    return { id, hasError: true, error: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // Здесь можно логировать ошибку в Sentry, LogRocket и т.п.
    console.error('Client error caught:', error, errorInfo);
  }

  // componentDidUpdate(_, prevState) {
  //   if (this.state.hasError && !prevState.hasError) {
  //     // Router.push(`/error-client?msg=${this.state.error}`);
  //   }
  // }

  componentDidMount() {
    window.addEventListener('error', this.showError);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.showError);
  }

  render() {
    const t = this.props.t;

    if (this.state.hasError && this.state.type === 'loading') return (
      <div className={classNames(styles.root, 'container')}>
        {/* <img src="/images/error-robot-2.svg" className={styles.image} alt={t('something_went_wrong')} />
        <div className={styles.content}>
          <CopyInput label={`${t('error_code')}:`} value={this.state.id} />
        </div> */}
        <div className={styles.content}>
          <div className={styles.title}>
            Медленное соединение
          </div>
          <div className={classNames(styles.descirption, styles.center)}>
            Ваше интернет-соединение слишком медленное, попробуйте позже или смените сеть
          </div>
        </div>
        <ButtonsContainer className={styles.buttons}>
          <Button size="medium" shadow={true} onClick={() => window.location.reload()}>
            Обновить страницу
          </Button>
        </ButtonsContainer>
      </div>
    );

    if (this.state.hasError) return (
      <div className={classNames(styles.root, 'container')}>
        <img src="/images/error-robot-2.svg" className={styles.image} alt={t('something_went_wrong')} />
        <div className={styles.content}>
          <CopyInput label={`${t('error_code')}:`} value={this.state.id} />
        </div>
        <div className={styles.content}>
          <div className={styles.descirption}>
            {t('something_went_wrong_description')}:
          </div>
          <ul className={styles.contacts}>
            <li><a className={styles.link} href={tgUrl} target="_blank" rel="noreferrer">Telegram</a></li>
            {/* <li><a className={styles.link} href={waUrl} target="_blank" rel="noreferrer">WhatsApp</a></li>*/}
            <li><a className={styles.link} href={`mailto:${email}`}>{email}</a></li>
          </ul>
        </div>
        <ButtonsContainer className={styles.buttons}>
          <Button size="medium" shadow={true} onClick={() => window.location.reload()}>
            Обновить страницу
          </Button>
        </ButtonsContainer>
      </div>
    );

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
